var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-circle"},[_c('svg',{staticClass:"bi bi-circle",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"fill":_vm.circleStyle,"viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }